// Action types for fetching data
export const FETCH_STORE_REQUEST = 'FETCH_STORE_REQUEST';
export const FETCH_STORE_SUCCESS = 'FETCH_STORE_SUCCESS';
export const FETCH_STORE_FAILURE = 'FETCH_STORE_FAILURE';
// Fetch data actions
export const fetchStoreRequest = () => ({
    type: FETCH_STORE_REQUEST,
});
export const fetchStoreSuccess = (payload) => ({
    type: FETCH_STORE_SUCCESS,
    payload,
});
export const fetchStoreFailure = (error) => ({
    type: FETCH_STORE_FAILURE,
    payload: error,
});
